import { Form, FormFieldType } from "../Form";

export class AssignmentForm extends Form {
  protected definition = {
    number: { required: true, type: FormFieldType.Text },
    date: { required: true, type: FormFieldType.Date },
    description: { required: false, type: FormFieldType.Text }
  };
}
